
import React from 'react';
import { Link } from 'react-router';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';

class MainNavHeader extends React.Component {
  render() {
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({id: message}, data);
    };
    const {authInfo} = this.props;

    return (<div className="brand-nav-bar">
      <div className="container">
        <nav className="navbar navbar-inverse" >
          <ul className="nav navbar-nav">
            <li>
              <Link activeClassName="active" to="/">{t('HOME')}</Link>
            </li>
            <li>
              <Link activeClassName="active" to="/browse-ideas">{t('LOCAL IDEAS')}</Link>
            </li>
            <li>
              <Link activeClassName="active" to="/cipGroups">{t('CIP-GROUPS')}</Link>
            </li>
            {
                (authInfo.Id) &&
                <li>
                  <Link activeClassName="active" to="/manage-ideas" >{t('MANAGE IDEAS')}</Link>
                </li>
              }
            {
                (authInfo.IsAdmin) &&
                <li>
                  <Link activeClassName="active" to="/users">{t('USERS')}</Link>
                </li>
              }
          </ul>
        </nav>
      </div>
    </div>);
  }
}

export default injectIntl(MainNavHeader);



// WEBPACK FOOTER //
// ./components/MainNavHeader.js